import { FOUNDER_COHORT_OPEN } from '@alexiarest/shared';

/** Parámetro canónico de las invitaciones Founder. */
export const FOUNDER_QUERY_PARAM = 'founder';

/**
 * Con la cohorte cerrada no hay invitación que valga: se devuelve '' y quien
 * llegue con un enlace guardado hace el alta normal, con su prueba gratuita.
 */
export function founderAccessCodeFrom(search: string, open: boolean = FOUNDER_COHORT_OPEN): string {
  if (!open) return '';
  const params = new URLSearchParams(search);
  const canonical = params.get(FOUNDER_QUERY_PARAM)?.trim();
  if (canonical) return canonical;

  // Compatibilidad con el enlace inicial ya compartido. Solo se admite el
  // prefijo Founder para no confundir un callback OAuth real con la invitación.
  const legacy = params.get('code')?.trim() ?? '';
  return legacy.startsWith('FOUNDER-') ? legacy : '';
}
